import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { CacheBypassInterceptor } from '../_providers/cachebypassinterceptor';
import { DelegationInterceptor } from '../_providers/delegationinterceptor';
import { HttpErrorInterceptor } from '../_providers/httpErrorInterceptor';
import { JsonDateInterceptor } from '../_providers/jsonDateInterceptor';
import { LanguageInterceptor } from '../_providers/languageInterceptor';
import { TokenInterceptor } from '../_providers/tokeninterceptor';

export const interceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DelegationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: JsonDateInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: CacheBypassInterceptor, multi: true },
  provideHttpClient(withXhr(), withInterceptorsFromDi()),
];
